// extracted by mini-css-extract-plugin
export default {"zero":"calculator_zero__luhAm"};